import React from "react";
import Router from "next/router";
import styles from "../../pages/current-affairs/blog/[slug].module.scss";

const SearchForm = ({ language }) => {
  const [search, setSearch] = React.useState({ search: "" });
  //   const language = language;

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setSearch((prevState) => ({ ...prevState, [name]: value }));

    // console.log("dsddsd")
  };

  const handleSearch = (e) => {
    e.preventDefault();
    Router.push({
      pathname: "/current-affairs/search",
      query: { query: search.search, lang: language },
    });
  };

  //   console.log("query:", search.search);

  return (
    <form className="search-form" onSubmit={handleSearch}>
      <input
        type="search"
        className={styles["search-field"]}
        placeholder="Search article here..."
        name="search"
        value={search.search}
        onChange={handleOnChange}
      />
      <button type="submit">
        {/* <i className="flaticon-search"></i> */}
        <i className="bx bx-search-alt"></i>
      </button>
    </form>
  );
};

export default SearchForm;
